import { render } from "./textbox.vue?vue&type=template&id=e63cc1c2&scoped=true"
import script from "./textbox.vue?vue&type=script&lang=js"
export * from "./textbox.vue?vue&type=script&lang=js"

import "./textbox.vue?vue&type=style&index=0&id=e63cc1c2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e63cc1c2"]])

export default __exports__